module.exports = __webpack_public_path__ + "media/images/landing/illustration-teamspirit-b72dee67a35c7eafea517d836e7c31f4.svg";